const numberSort = (rowA, rowB, columnId) => {
    const a = parseFloat(rowA.values[columnId]) || 0;
    const b = parseFloat(rowB.values[columnId]) || 0;
    return a - b;
};

export default numberSort;